(function (angular, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.API
        .factory('MembershipModel', ['$http', '$q', function ($http, $q) {
            var MembershipModel = function () {

            };

            MembershipModel.prototype = {
                _items: [],

                removeSensitiveData: function(data) {
                    // Clear out payment information
                    data.payment.paymentAccountName = '';
                    data.payment.paymentAccountNumber = '';
                    data.payment.paymentAccountBSB = '';
                    data.payment.benefitsAccountName = '';
                    data.payment.benefitsAccountNumber = '';
                    data.payment.benefitsAccountBSB = '';
                    data.personal.medicareNumber = '';
                    data.confirm.declareRebate = '';
                    data.confirm.declareInfo = '';

                    return data;
                },

                create: function (memberPassword, email, tabName, data) {
                    var deferred = $q.defer();

                    var saveData = angular.copy(data);
                    saveData = this.removeSensitiveData(saveData);

                    var req = {
                        method: 'POST',
                        url: '/api/v1/website/memberships/',
                        headers: {
                            'X-MemberPassword': memberPassword
                        },
                        data: JSON.stringify({
                            Email: email,
                            TabName: tabName,
                            Application: saveData
                        })
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                },
                update: function (applicationId, email, memberPassword, tabName, data) {
                    var deferred = $q.defer();

                    var saveData = angular.copy(data);
                    saveData = this.removeSensitiveData(saveData);

                    var req = {
                        method: 'PUT',
                        url: '/api/v1/website/memberships/' + applicationId,
                        headers: {
                            'X-MemberPassword': memberPassword
                        },
                        data: JSON.stringify({
                            Email: email,
                            TabName: tabName,
                            Application: saveData
                        })
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                },
                get: function (applicationId, memberPassword) {
                    var deferred = $q.defer();
                    var req = {
                        method: 'GET',
                        url: '/api/v1/website/memberships/' + applicationId,
                        headers: {
                            'X-MemberPassword': memberPassword
                        }
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                },
                submit: function (email, submission, applicationId) {
                    applicationId = applicationId || null;
                    var deferred = $q.defer();
                    var req = {
                        method: 'POST',
                        url: '/api/v1/members/submit',
                        data: JSON.stringify({
                            Email: email,
                            ApplicationId: applicationId,
                            Submission: submission
                        })
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                }
            };

            return new MembershipModel();
        }]);

})(angular, window);
